import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import Bind from 'lodash-decorators/bind';
import Debounce from 'lodash-decorators/debounce';
import OptimizeImagesService from 'services/OptimizeImages.service';

import styles from './EmployeeCard.module.scss';

import { Container } from 'common/components/Layout/Layout';

import { isOnMobile } from 'utils/device-utils.js';

export default class FiltersComponent extends Component {
  static propTypes = {
    className: PropTypes.string,
    employee: PropTypes.object.isRequired
  };

  static defaultProps = {
    className: '',
    employee: []
  };

  constructor(props) {
    super(props);

    this.state = {
      isMobile: isOnMobile(),
      employee: props.employee
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  static getDerivedStateFromProps(nextProps, prevProps) {
    return {
      employee: nextProps.employee
    };
  }

  render() {
    const { className } = this.props;
    const { employee } = this.state;
    return this.state.isMobile
      ? this.mobile(className, employee)
      : this.desktop(className, employee);
  }

  desktop(className, employee) {
    return (
      <div className={` ${styles.EmployeeCard} ${className} `}>
        <div className={styles.EmployeeCardLeftColumn}>
          <img
            className={styles.EmployeeCardImage}
            src={OptimizeImagesService.adjustImageSize(employee.photo)}
            alt="avatar"
          />
        </div>
        <div className={styles.EmployeeCardRightColumn}>
          <div className={styles.EmployeeCardHeader}>
            <h2 className={styles.EmployeeCardName}>{employee.fullName}</h2>
            {employee.linkedInLink && (
              <div>
                <a
                  href={employee.linkedInLink}
                  className={styles.EmployeeCardSocial}
                  rel="nofollow"
                >
                  <FontAwesomeIcon
                    icon={['fab', 'linkedin-in']}
                    className={styles.EmployeeCardSocialIcon}
                  />
                </a>
              </div>
            )}
          </div>
          <div className={styles.EmployeeCardPosition}>{employee.position}</div>
          <div
            className={styles.EmployeeCardAbout}
            dangerouslySetInnerHTML={{ __html: employee.description }}
          />
          <div className={styles.EmployeeCardContactWrapper}>
            {employee.phoneNumber && (
              <div className={styles.EmployeeCardContact}>
                <div className={styles.EmployeeCardContactIconWrapper}>
                  <FontAwesomeIcon
                    icon={['fas', 'mobile-alt']}
                    className={styles.EmployeeCardContactIcon}
                  />
                </div>
                <a
                  href={`tel:${employee.phoneNumber}`}
                  className={styles.EmployeeCardContactLink}
                >
                  {employee.phoneNumber}
                </a>
              </div>
            )}
            {employee.email && (
              <div className={styles.EmployeeCardContact}>
                <div className={styles.EmployeeCardContactIconWrapper}>
                  <FontAwesomeIcon
                    icon={['far', 'envelope']}
                    className={styles.EmployeeCardContactIcon}
                  />
                </div>
                <a
                  href={`mailto:${employee.email}`}
                  className={styles.EmployeeCardContactLink}
                >
                  {employee.email}
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  mobile(className, employee) {
    return (
      <Container className={` ${styles.EmployeeCard}-mobile ${className} `}>
        <Container className={styles.AvatarBox}>
          <img
            className={styles.Avatar}
            src={OptimizeImagesService.adjustImageSize(employee.photo)}
            alt="avatar"
          />
        </Container>
        <Container className={styles.EmployeeDescriptionBox}>
          <p className={styles.Name}>{employee.firstName}</p>
          <p className={styles.Name}>{employee.lastName}</p>
          <p className={styles.Position}>{employee.position}</p>
          <div
            className={styles.Description}
            dangerouslySetInnerHTML={{ __html: employee.description }}
          />
          <div className={styles.Contact}>
            <div className={styles.Phone}>
              <div
                className={`${styles.EmployeeCardContactIconWrapper}-mobile`}
              >
                <FontAwesomeIcon
                  icon={['fas', 'mobile-alt']}
                  className={styles.Icon}
                />
              </div>
              <p>{employee.phoneNumber}</p>
            </div>
            <div className={styles.Mail}>
              <div
                className={`${styles.EmployeeCardContactIconWrapper}-mobile`}
              >
                <FontAwesomeIcon
                  icon={['far', 'envelope']}
                  className={styles.Icon}
                />
              </div>
              <p>{employee.email}</p>
            </div>
          </div>
        </Container>
      </Container>
    );
  }

  @Bind()
  @Debounce(100)
  updateDimensions() {
    this.setState({
      isMobile: isOnMobile()
    });
  }
}



// WEBPACK FOOTER //
// ./src/views/TeamOfExperts/components/EmployeeCard/EmployeeCard.js